import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { apiFetch } from './services/apiClient';
import './ThankYouPage.css';

const AlreadyAppliedPage = () => {
    const { jobId, slug } = useParams();
    const [formSettings, setFormSettings] = useState(null);

    useEffect(() => {
        if (slug) return; // Slug route: use fallback theme
        if (jobId) fetchFormSettings();
    }, [jobId, slug]);

    const fetchFormSettings = async () => {
        try {
            const response = await apiFetch(`/api/jobs/${jobId}/form-settings`);
            if (response.ok) {
                const data = await response.json();
                setFormSettings(data);
            }
        } catch (error) {
            console.error('Error fetching form settings:', error);
        }
    };

    const activeSettings = formSettings || {
        form_background_color: '#f5f5f5',
        form_text_color: '#333333',
        form_primary_color: '#667eea'
    };

    const backgroundStyle = activeSettings.form_background_color === '#f5f5f5' || !activeSettings.form_background_color
        ? {
            backgroundColor: '#0c001f',
            backgroundImage: `
                radial-gradient(at 20% 20%, hsla(28,100%,74%,0.15) 0px, transparent 50%),
                radial-gradient(at 80% 20%, hsla(217,100%,50%,0.15) 0px, transparent 50%),
                radial-gradient(at 80% 80%, hsla(339,100%,50%,0.15) 0px, transparent 50%),
                radial-gradient(at 20% 80%, hsla(140,100%,50%,0.15) 0px, transparent 50%)
            `
          }
        : { backgroundColor: activeSettings.form_background_color };

    return (
        <div
            className="thank-you-page"
            style={{
                ...backgroundStyle,
                color: activeSettings.form_text_color || '#333333',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem'
            }}
        >
            <div className="thank-you-container">
                <div className="thank-you-icon">✓</div>
                <h1>Already applied</h1>
                <p>You have already applied for this job.</p>
                <p>We have received your application and will review it. You do not need to apply again.</p>
            </div>
        </div>
    );
};

export default AlreadyAppliedPage;
